const UPPERCASE_IATA = /^[A-Z]{3}$/

/**
 * Normalizes airport codes for item-policy POST /calculate and GET …/budgets.
 * Backend expects exactly three ASCII letters A–Z (see svc-business airportCodeSchema).
 */
export function normalizeFlightIataAirportCodeForItemPolicy(raw?: string | null): string | undefined {
  if (raw == null || raw.trim() === '') {
    return undefined
  }
  const lettersOnly = raw.replace(/[^a-zA-Z]/g, '').slice(0, 3).toUpperCase()
  return UPPERCASE_IATA.test(lettersOnly) ? lettersOnly : undefined
}
